import { useState } from 'react';
import { Chip, Stack } from '@mui/material';
import { ModalitiesEditDialog } from './modalities-edit-dialog';
import { ModalitiesLabels } from '@/constants/recommendation';
import { useRecommendationProfile } from '@/context/recommendation-profile';
import type { Modalities as ModalitiesEnum } from '@/models/recommendation';
import { ProfileItem } from '@/packages/my-profile/components/profile-item';

export const Modalities = () => {
  const { profile, updateProfile } = useRecommendationProfile();
  const [isDialogOpen, setIsDialogOpen] = useState(false);

  const handleSave = (selectedModalities: ModalitiesEnum[]) => {
    updateProfile({
      profile: {
        ...profile,
        modalities: selectedModalities,
      },
    });
    setIsDialogOpen(false);
  };

  const hasModalities = profile?.modalities && profile?.modalities?.length > 0;

  return (
    <>
      <ProfileItem title="Modalidades" onClick={() => setIsDialogOpen(true)}>
        {hasModalities && (
          <Stack direction="row" gap={2} flexWrap="wrap">
            {profile?.modalities?.map((modality: ModalitiesEnum) => (
              <Chip key={modality} label={ModalitiesLabels[modality]} />
            ))}
          </Stack>
        )}
      </ProfileItem>
      {isDialogOpen && profile && (
        <ModalitiesEditDialog
          currentValues={profile?.modalities || []}
          onClose={() => setIsDialogOpen(false)}
          onSave={handleSave}
        />
      )}
    </>
  );
};
